<template>
  <div class="commission pb-9">
    <v-card class="common-card">
      <div class="d-flex flex-column flex-md-row">
        <h4 class="c-grey pt-2">کمیسیون فروشنده‌ها</h4>
        <v-divider
          class="me-10 ms-10 d-none d-sm-none d-md-block"
          vertical
        ></v-divider>
        <div class="custom-input2">
          <v-text-field
            hide-details
            outlined
            dense
            label="جستجو در نام فروشنده..."
            prepend-icon="$Search"
            @input="currentPage = 1"
            v-model="filter"
            class="mt-5 mt-sm-5 mt-md-0"
          >
            <template v-slot:append>
              <v-icon
                v-if="filter.length"
                class="red--text text--lighten-2"
                @click="
                  filter = '';
                  currentPage = 1;
                "
                >mdi-close-circle</v-icon
              >
            </template>
          </v-text-field>
        </div>
      </div>
      <hr class="mt-5" />
      <div class="mt-6 custom-input d-flex">
        <b class="pt-3 pe-3">از تاریخ:</b>
        <span id="fromDate"
          ><v-text-field
            dense
            outlined
            v-model="fromDate"
            append-icon="mdi-calendar"
          ></v-text-field
        ></span>
        <date-picker
          element="fromDate"
          v-model="fromDate"
          color="#6200ea"
        ></date-picker>

        <b class="pt-3 pe-3 ms-6">تا تاریخ:</b>
        <span id="toDate"
          ><v-text-field
            dense
            outlined
            v-model="toDate"
            append-icon="mdi-calendar"
          ></v-text-field
        ></span>
        <date-picker
          element="toDate"
          v-model="toDate"
          color="#6200ea"
        ></date-picker>
        <v-btn @click="getCommission()" class="orange-mainBtn ms-4" height="42"
          >اعمال</v-btn
        >
      </div>
      <v-card v-if="loading" flat>
        <div class="d-flex flex-column align-items-center mt-8 py-6">
          <atom-spinner
            :animation-duration="1000"
            :size="80"
            :color="'#6200ea'"
          />
          <p class="primary--text font-weight-bold mt-4">
            در حال بارگذاری اطلاعات...
          </p>
        </div>
      </v-card>
      <v-card v-else flat>
        <v-container class="pt-12">
          <div class="custom-table mt-3">
            <b-table
              responsive
              show-empty
              :current-page="currentPage"
              :per-page="perPage"
              :items="computedCommission"
              :fields="fields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد."
              striped
              thead-class="headClass"
              tbody-class="bodyClass"
            >
              <template v-slot:empty>
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  رکوردی برای نمایش وجود ندارد.
                </div>
              </template>
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPage - 1) }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(userName)="data">
                <div style="text-align: center; vertical-align: middle">
                  <b> {{ data.value }} </b>
                </div>
              </template>
              <template v-slot:cell(totalSales)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }} تومان
                </div>
              </template>
              <template v-slot:cell(totalCommissions)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }} تومان
                </div>
              </template>

              <template v-slot:cell(operation)="row">
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  <v-btn
                    v-if="!row.item._showDetails"
                    @click="row.toggleDetails"
                    class="orange-mainBtn"
                    >نمایش کمیسیون روزانه</v-btn
                  >
                  <v-btn
                    v-else
                    @click="row.toggleDetails"
                    class="red-mainBtn"
                    width="120"
                    >بستن</v-btn
                  >
                </div>
              </template>
              <template #row-details="row">
                <div>
                  <b-table
                    responsive
                    show-empty
                    :current-page="innerCurrentPage[row.index]"
                    :per-page="innerPerPage"
                    :items="row.item.daysStats"
                    :fields="innerFields"
                    empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                    empty-text="رکوردی برای نمایش وجود ندارد."
                    striped
                    thead-class="headClass"
                    tbody-class="bodyClass"
                  >
                    <template v-slot:empty>
                      <div
                        style="text-align: center; vertical-align: middle"
                        class="pt-0"
                      >
                        رکوردی برای نمایش وجود ندارد.
                      </div>
                    </template>
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(sum)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ Number(data.value).toLocaleString() }} تومان
                      </div>
                    </template>
                    <template v-slot:cell(commission)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ Number(data.value).toLocaleString() }} تومان
                      </div>
                    </template>
                  </b-table>
                  <v-row class="mt-6 inner-pagination">
                    <v-col class="text-center">
                      <div>
                        <v-pagination
                          v-model="innerCurrentPage[row.index]"
                          :length="
                            Math.ceil(row.item.daysStats.length / innerPerPage)
                          "
                          :total-visible="5"
                        ></v-pagination>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </template>
            </b-table>
            <v-row class="mt-6">
              <v-col class="d-flex flex-row">
                <span class="c-grey pt-2">نمایش در هر صفحه</span>
                <div class="ms-3 me-3 number-box">
                  <v-select
                    outlined
                    v-model="perPage"
                    :items="perPageOptions"
                    @change="currentPage = 1"
                  ></v-select>
                </div>
              </v-col>
              <v-col class="d-flex flex-row">
                <span class="c-grey pt-2"> برو به صفحه </span>
                <div class="ms-3 me-3 number-box">
                  <v-select
                    outlined
                    v-model="whichPage"
                    type="number"
                    @change="goToPage()"
                    @click="goToPage()"
                    :items="computedIndex"
                  ></v-select>
                </div>
              </v-col>
              <v-col class="text-sm-left text-center">
                <div>
                  <v-pagination
                    v-model="currentPage"
                    :length="Math.ceil(computedCommission.length / perPage)"
                    :total-visible="5"
                    prev-icon="$ArrowLeft"
                    next-icon="$ArrowRight"
                    class="float-sm-end"
                  ></v-pagination>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card>
    </v-card>
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import moment from "moment-jalaali";
import Axios from "axios";
import { AtomSpinner } from "epic-spinners";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    AtomSpinner,
  },
  data() {
    return {
      moment: moment,
      fromDate: moment(new Date())
        .subtract(1, "jMonth")
        .format("jYYYY/jMM/jDD"),
      toDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      filter: "",
      perPage: 10,
      currentPage: 1,
      innerPerPage: 6,
      innerCurrentPage: [],
      perPageOptions: [4, 10, 20],
      commission: [],
      loading: false,
      fields: [
        { key: "index", label: "ردیف" },
        { key: "userName", label: "نام فروشنده" },
        { key: "totalSales", label: "مجموع فروش" },
        { key: "totalCommissions", label: "مجموع کمیسیون" },
        { key: "operation", label: "عملیات" },
      ],
      innerFields: [
        { key: "day", label: "تاریخ" },
        { key: "sum", label: "فروش" },
        { key: "commission", label: "کمیسیون" },
      ],
      whichPage: 1,
    };
  },

  mounted() {
    this.getCommission();
  },

  methods: {
    goToPage() {
      this.currentPage = Number(this.whichPage);
    },
    getCommission() {
      this.loading = true;
      Axios.post(
        this.baseUrl + "/satrapp/shop/reports/commissionReport",
        {
          startDate: this.fromDate,
          endDate: this.toDate,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.commission = res.data;
            this.commission.forEach(() => {
              this.innerCurrentPage.push(1);
            });
            this.loading = false;
          } else {
            this.toast(res.data, "error");
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
  },

  computed: {
    computedCommission() {
      let filtered = this.commission.filter((x) =>
        x.userName.includes(this.filter)
      );
      return filtered;
    },
    computedIndex() {
      let arr = [];
      let computedLength = this.computedCommission.length;
      let arrLength = Math.ceil(computedLength / this.perPage);
      for (let i = 1; i <= arrLength; i++) {
        arr.push(i);
      }
      return arr;
    },
  },
};
</script>

<style lang="scss">
.commission {
  .custom-input {
    .v-input__slot {
      width: 150px !important;
      i {
        margin-top: 6px;
      }
    }
  }
}
</style>
